import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
import { formatarMoeda, isJsonString } from '../../../../util/Utilitarios';
import { capitalize } from 'lodash';
import { formatarErroNota } from '../../../../util/FuncoesComuns';
import { ModalPadraoCadastro } from '../../../../components/Modais';
var format = require('xml-formatter');

// Percentual gravado como número (60 = 60%); vazio quando não há classificação
const percentual = (valor) => (valor === null || valor === undefined || valor === '') ? undefined : `${parseFloat(valor).toFixed(2).replace('.', ',')}%`
// Alíquota do ISS que a prefeitura aplica à atividade (0 = sem ISS por nota, caso ALFA/EQUIPE)
const aliquotaAtividade = (atividade) => {
    if (!atividade) return undefined
    if (atividade.aliquota === null || atividade.aliquota === undefined || atividade.aliquota === '') return 'Não cadastrada'
    return `${parseFloat(atividade.aliquota).toFixed(2).replace('.', ',')}%`
}

const VisualizacaoNota = props => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/financeiro/notafiscal', id,
            obj => {

                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Visualização Nota Fiscal',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj?.id, tamanho: 'col-lg-4' },
                                { titulo: 'Número NFS-e', descricao: obj?.numero, tamanho: 'col-lg-4' },
                                { titulo: 'Código Verificação', descricao: obj?.codigo_verificacao, tamanho: 'col-lg-4' },
                                { titulo: 'Data Emissão', descricao: obj?.data_emissao, tamanho: 'col-lg-4' },
                                { titulo: 'Tomador/Cliente', descricao: obj?.cliente?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Empresa/Prestador', descricao: obj?.empresa?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Data Registro', descricao: obj?.data_registro, tamanho: 'col-lg-4' },
                                { titulo: 'Natureza da Operação', descricao: obj?.natureza_operacao?.label, tamanho: 'col-lg-4' },
                                { titulo: 'CNAE', descricao: obj?.cnae?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Lista de Serviço', descricao: obj?.lista_servico?.label, tamanho: 'col-lg-4' },
                                { titulo: 'NBS', descricao: obj?.nbs?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Atividade Municipal', descricao: obj?.empresa_atividade_municipal?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Alíquota ISS da Atividade', descricao: aliquotaAtividade(obj?.empresa_atividade_municipal), tamanho: 'col-lg-4' },
                                { titulo: 'ISS Retido (pelo tomador)', descricao: obj?.iss_retido ? 'Sim' : 'Não', tamanho: 'col-lg-4' },
                                { titulo: 'DPS (Série / Número)', descricao: obj?.numero_rps ? `${obj?.serie_rps || ''} / ${obj?.numero_rps}` : undefined, tamanho: 'col-lg-4' },
                                                        ]
                        },
                        {
                            titulo: 'Tributação Federal (PIS/COFINS)',
                            colunas: [
                                { titulo: 'Situação Tributária do PIS/COFINS', descricao: obj?.pis_cofins_situacao_tributaria?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Tipo de Retenção do PIS/COFINS/CSLL', descricao: obj?.pis_cofins_csll_tipo_retencao?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Base de Cálculo PIS/COFINS', descricao: obj?.base_calculo_pis_cofins != null ? formatarMoeda(obj.base_calculo_pis_cofins) : undefined, tamanho: 'col-lg-4' },
                            ]
                        },
                        {
                            titulo: 'Imposto e Contribuição sobre Bens e Serviços (IBS/CBS)',
                            colunas: [
                                { titulo: 'Indicador da Operação', descricao: obj?.ibs_cbs_indicador_operacao?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Classificação Tributária', descricao: obj?.ibs_cbs_classificacao_tributaria?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Situação Tributária (CST)', descricao: obj?.ibs_cbs_situacao_tributaria?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Redução CBS', descricao: percentual(obj?.ibs_cbs_classificacao_tributaria?.percentual_reducao_cbs), tamanho: 'col-lg-4' },
                                { titulo: 'Redução IBS', descricao: percentual(obj?.ibs_cbs_classificacao_tributaria?.percentual_reducao_ibs), tamanho: 'col-lg-4' },
                            ]
                        },
                        {
                            tipoGrupo: 'tabela',
                            titulo: 'Lançamento(s)',
                            visivel: obj.lancamentos.length > 0,
                            // aposGrupo: <tr>
                            //     <td style={{ textAlign: 'right', fontWeight: 'bold' }} colSpan={13}>{formatarMoeda(obj.lancamentos.map(item => item.valor_total).reduce((total, num) => parseFloat(total) + parseFloat(num)))}</td>
                            // </tr>,
                            thead:
                                <tr>
                                    <td className='coluna-1' colspan="1">Lançamento</td>
                                    <td className='coluna-3' colspan="3" style={{ textAlign: 'right' }}>Valor Lançamento</td>
                                </tr>,
                            tbody: obj?.lancamentos == undefined || obj?.lancamentos.length < 1 || obj?.lancamentos.filter(x => x.id !== null).length === 0 ? (<><tr>
                                <td colspan="3">Sem Registro!</td>
                            </tr></>) :

                                obj?.lancamentos.map(x => {
                                    return (
                                        <tr>
                                            <td colspan="3">{x?.lancamento?.label}</td>
                                            <td colspan="1" style={{ textAlign: 'right' }}>{x?.valor_lancamento && formatarMoeda(x?.valor_lancamento)}</td>
                                        </tr>)
                                })
                        },
                        {
                            titulo: 'Dados Serviço',
                            colunas: [
                                { titulo: 'Município-UF', descricao: obj.municipio?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Discriminação Serviços', descricao: obj.discriminacao_servicos, tamanho: 'col-lg-4' },
                                { titulo: 'Informações Adicionais', descricao: obj.informacoes_adicionais, tamanho: 'col-lg-4' },
                                { titulo: 'Valor R$', descricao: obj.valor_servico_formatado, tamanho: 'col-lg-4' },
                                { titulo: 'Valor Desconto R$', descricao: obj.valor_desconto_formatado, tamanho: 'col-lg-4' },
                                { titulo: 'Base Cálculo R$', descricao: obj.valor_base_calculo_formatado, tamanho: 'col-lg-4' },
                                { titulo: 'Valor Dedução R$', descricao: obj.valor_deducao_formatado, tamanho: 'col-lg-4' },
                                { titulo: 'Valor Nota R$', descricao: obj.valor_nota_formatado, tamanho: 'col-lg-4' },
                                
                            ]
                        },
                        {
                            tipoGrupo: 'tabela',
                            titulo: 'Tributo(s)',
                            visivel: obj.tributos.length > 0,
                            // aposGrupo: <tr>
                            //     <td style={{ textAlign: 'right', fontWeight: 'bold' }} colSpan={13}>{formatarMoeda(obj.lancamentos.map(item => item.valor_total).reduce((total, num) => parseFloat(total) + parseFloat(num)))}</td>
                            // </tr>,
                            thead:
                                <tr>
                                    <td className='coluna-1' colspan="1">Situação</td>
                                    <td className='coluna-1' colspan="1">Recolhimento</td>
                                    <td className='coluna-1' colspan="1">Tributo</td>
                                    <td className='coluna-1' colspan="1">Local Incidência</td>
                                    <td className='coluna-3' colspan="3" style={{ textAlign: 'right' }}>Valor Tributo</td>
                                </tr>,
                            tbody: obj?.tributos == undefined || obj?.tributos.length < 1 || obj?.tributos.filter(x => x.id !== null).length === 0 ? (<><tr>
                                <td colspan="3">Sem Registro!</td>
                            </tr></>) :

                                obj?.tributos.map(x => {
                                    return (
                                        <tr>
                                            <td colspan="1">{x?.situacao?.label}</td>
                                            <td colspan="1">{x?.recolhimento?.label}</td>
                                            <td colspan="1">{x?.tributo?.label}</td>
                                            <td colspan="1">{x?.local_incidencia?.label}</td>
                                            <td colspan="3 " style={{ textAlign: 'right' }}>{x?.valor_tributo && formatarMoeda(x?.valor_tributo)}</td>
                                        </tr>)
                                })
                        },
                        // {
                        //     tipoGrupo: 'tabela',
                        //     titulo: 'Visualizar Notas',
                        //     visivel: true,
                        //     aposGrupo: <tr>
                        //         <td style={{ textAlign: 'right', fontWeight: 'bold' }} colSpan={13}>http://www2.goiania.go.gov.br/sistemas/snfse/asp/snfse00200w0.asp?inscricao=1300687&nota=370&verificador=MB94-C3ZA</td>
                        //     </tr>,
                        //     tbody: <tr>
                        //         <td colspan="3">http://www2.goiania.go.gov.br/sistemas/snfse/asp/snfse00200w0.asp?inscricao=1300687&nota=370&verificador=MB94-C3ZA!</td>
                        //     </tr>
                        // },

                    ]
                } : { titulo: 'Visualização Nota Fiscal' })

            })

    }, [id])


    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

const VisualizacaoErrosNota = (props) => {
  let { id } = useParams();
  const [dados, setDados] = useState();

  useEffect(() => {
    visualizar('/financeiro/obterErrosEnvioNota', id, (obj) => {
      if (!obj || !obj.length) {
        setDados({ titulo: 'Visualização de Erro Nota' });
        return;
      }

      const nota = obj[0];

      setDados({
        id,
        modulo: props.modulo,
        titulo: 'Visualização de Erro Nota',
        grupos: [
          {
            titulo: 'Dados Nota Fiscal',
            colunas: [
              { titulo: 'Número', descricao: nota.numero, tamanho: 'col-lg-3' },
              { titulo: 'Prestador/Empresa', descricao: nota.prestador, tamanho: 'col-lg-3' },
              { titulo: 'Data Emissão', descricao: nota.data_emissao, tamanho: 'col-lg-3' },
              { titulo: 'Valor Nota', descricao: nota.valor_nota_formatado, tamanho: 'col-lg-3' },
              { titulo: 'Tomador/Cliente', descricao: nota.cliente?.label, tamanho: 'col-lg-6' },
            ],
          },
          {
            tipoGrupo: 'tabela',
            titulo: 'Erros do Envio',
            visivel: nota.erros && nota.erros.length > 0,
            thead: (
              <tr>
                <td className="coluna-2">Código</td>
                <td className="coluna-4">Erro</td>
                <td className="coluna-4">Correção</td>
                <td className="coluna-2">Data</td>
              </tr>
            ),
            tbody:
              !nota.erros || nota.erros.length === 0 ? (
                <tr>
                  <td colSpan={4}>Nenhum erro encontrado</td>
                </tr>
              ) : (
                nota.erros.map((erro) => (
                  <tr key={erro.id}>
                    <td>{erro.codigo || '-'}</td>
                    <td>{erro.erro || '-'}</td>
                    <td>{erro.correcao || '-'}</td>
                    <td>{erro.data_registro}</td>
                  </tr>
                ))
              ),
          },
        ],
      });
    });
  }, [id]);

  return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null;
};

const DetalhesNota = (props) => {
    const [itemDetalhes, setItemDetalhes] = useState({});

    useEffect(() => {
        setItemDetalhes(props.itemDetalhes)
    }, [props.itemDetalhes])

    return <ModalPadraoCadastro titulo={props.titulo || 'Detalhes Nota Fiscal'} showModal={props.showModal} setShowModal={props.setShowModal}>
        <div><div className='detalhes'>
            {itemDetalhes.nota_fiscal && itemDetalhes.nota_fiscal.map((item, idx) => {
                return (
                    <>
                        {idx === 0 ? <></> : <hr />}
                        <div className='item-detalhes'>
                            <h6><b>{item?.titulo}</b></h6>
                            <h6>{item?.descricao}</h6>
                            {item.html}
                        </div></>
                )
            })}

        </div>
            {
                itemDetalhes.nota_substituicao ?
                    <>
                        <div className="modal-header">
                            <h5 className="modal-title"><span>Substituição</span></h5>
                        </div>
                        <div>
                            <ul className='lista-modal'>
                                <li className="mb-1">
                                    <div className='item-detalhes row-space-between'>
                                        <h6><b>NF Substituída</b></h6>
                                        <h6><b>NF Substituta</b></h6>
                                    </div>
                                    <div className='item-detalhes row-space-between'>
                                        <h6>Nº {itemDetalhes.nota_substituicao.numero_substituida}</h6>
                                        <h6>Nº {itemDetalhes.nota_substituicao.numero_substituta}</h6>
                                    </div>
                                    <hr />
                                    <div className='item-detalhes'>
                                        <h6><b>Justificativa</b></h6>
                                    </div>
                                    <div className='item-detalhes'>
                                        <h6>{itemDetalhes.nota_substituicao.justificativa || '---'}</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </>
                    : <></>
            }
            {
                itemDetalhes.nota_lancamento && itemDetalhes.nota_lancamento.length > 0 ?
                    <div className="modal-header">
                        <h5 className="modal-title"><span>Lançamento(s)</span></h5>
                    </div>
                    : <></>
            }
            <div>
                <ul className='lista-modal'>
                    {
                        itemDetalhes.nota_lancamento && itemDetalhes.nota_lancamento.map(item => <li className="mb-1">
                            <div className='item-detalhes row-space-between'>
                                <h6><b>Cód</b></h6>
                                <h6><b>Data Registro</b></h6>
                            </div>
                            <div className='item-detalhes row-space-between'>
                                <h6>{item.id}</h6>
                                <h6>{item.data_registro}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Empresa</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{item.empresa || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Cliente</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{(item?.cpf_cnpj + ' - ' + item.cliente) || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Estabelecimento Saúde</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{item.estabelecimento_saude || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Descrição</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{item.descricao || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes row-space-between'>
                                <h6><b>Tipo Pagamento</b></h6>
                                <h6><b>Tipo Documento</b></h6>
                            </div>
                            <div className='item-detalhes row-space-between'>
                                <h6>{item.modo_pagamento_sigla || '---'}</h6>
                                <h6>{item.tipo_documento_lancamento || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes row-space-between'>
                                <h6><b>Data Liquidação</b></h6>
                                <h6><b>Valor R$</b></h6>
                            </div>
                            <div className='item-detalhes row-space-between'>
                                <h6>{item.data_liquidacao || '---'}</h6>
                                <h6>{item.valor_liquidacao || '---'}</h6>
                            </div>
                            <hr />

                        </li>)
                    }
                </ul>
            </div>
            {
                itemDetalhes.nota_guia && itemDetalhes.nota_guia.length > 0 ?
                    <div className="modal-header">
                        <h5 className="modal-title"><span>Guia</span></h5>
                    </div>
                    : <></>
            }
            <div>
                <ul className='lista-modal'>
                    {
                        itemDetalhes?.nota_guia && itemDetalhes?.nota_guia?.map(item => <li className="mb-1">
                            <div className='item-detalhes row-space-between'>
                                <h6><b>Código</b></h6>
                                <h6><b>Data Registro</b></h6>
                            </div>
                            <div className='item-detalhes row-space-between'>
                                <h6>{item.id}</h6>
                                <h6>{item.data_registro}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Paciente</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{item.nome_beneficiario || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Profissional(is) Executante(s) Cooperativa (CONVÊNIO)</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{item?.socio_externo || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes'>
                                <h6><b>Profissional(is) Executante(s) EQUIPE</b></h6>
                            </div>
                            <div className='item-detalhes'>
                                <h6>{item?.socio_interno || '---'}</h6>
                            </div>
                            <hr />
                            <div className='item-detalhes row-space-between'>
                                <h6><b>Data Procedimento</b></h6>
                                <h6><b>Valor R$</b></h6>
                            </div>
                            <div className='item-detalhes row-space-between'>
                                <h6>{item.data_procedimento || '---'}</h6>
                                <h6>{item.valor_total || '---'}</h6>
                            </div>
                            <hr />

                        </li>)
                    }
                </ul>
            </div>
            {
                itemDetalhes.historico && itemDetalhes.historico.length > 0 ?
                    <div className="modal-header">
                        <h5 className="modal-title"><span>Histórico de Status</span></h5>
                    </div>
                    : <></>
            }
            <div>
                <ul className='lista-modal'>
                    {
                        itemDetalhes.historico && itemDetalhes.historico.map(item => <li className="mb-1">
                            <div className='col-hora row-space-between'>
                                <span className={'tag'} style={{ background: item.cor_id, color: 'white' }}>{item.descricao_status}</span> <span className='span-hora'>{item.data_registro}</span>
                            </div>
                            <div className='mt-2'>
                                <i><p>{item.anotacao}</p></i>
                            </div>
                            <div className='col-hora row-space-between'>
                                <span></span>
                                <span className='span-nome'><b>{`${item.usuario ? item.usuario.toUpperCase() : ''} `}</b></span>
                            </div>
                        </li>)
                    }
                </ul>
            </div>
            {
                itemDetalhes.historico_envio && itemDetalhes.historico_envio.length > 0 ?
                    <div className="modal-header">
                        <h5 className="modal-title"><span>Histórico de Status Envio</span></h5>
                    </div>
                    : <></>
            }
            <div>
                <ul className='lista-modal'>
                    {
                        itemDetalhes.historico_envio && itemDetalhes.historico_envio.map(item => <li className="mb-1">
                            <div className='col-hora row-space-between'>
                                <span className={'tag'} style={{ background: item.cor_id, color: 'white' }}>{item.descricao_status}</span> <span className='span-hora'>{item.data_registro}</span>
                            </div>
                            <div className='mt-2'>
                                <i><p>{item.anotacao}</p></i>
                            </div>
                            <div className='col-hora row-space-between'>
                                <span></span>
                                <span className='span-nome'><b>{`${item.usuario ? item.usuario.toUpperCase() : ''} `}</b></span>
                            </div>
                        </li>)
                    }
                </ul>
            </div>
        </div>
    </ModalPadraoCadastro >
}



export default VisualizacaoNota
export { VisualizacaoErrosNota, DetalhesNota }
